<template>
  <FreeModal
    :name="modalName"
    :persistent="persistentModal"
    :with-blackout="modalWithBlackout"
    class="text-center"
  >
    <template v-if="title" #header>
      <h1 class="text-lg font-semibold">{{ title }}</h1>
    </template>
    <template #default="{ hide }">
      <p
        v-if="message"
        class="text-text-neutral-secondary mt-1 text-sm font-medium"
      >
        {{ message }}
      </p>
      <FreeButton
        type="button"
        class="gray-button mt-6 w-full"
        @click="
          () => {
            emit('onProceed');
            hide();
          }
        "
      >
        {{ actionText }}
      </FreeButton>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';
  import { FreeModal, FreeButton } from '../../shared/ui';

  const props = defineProps<{
    modalName: string;
    persistentModal?: boolean;
    modalWithBlackout?: boolean;
  }>();

  const emit = defineEmits<{
    onProceed: [];
  }>();

  const { t } = useI18n();

  const modal = controllerModel.useModal();

  const params = computed(() => modal.getParams(props.modalName));
  const title = computed(() => params.value.title);
  const message = computed(() => params.value.message);
  const actionText = computed(
    () => params.value.actionText || t('errorModal.ok'),
  );
</script>

<i18n src="./config/locales.json"></i18n>
